import { render, staticRenderFns } from "./MypageMessageNotice.vue?vue&type=template&id=24f83487&scoped=true"
import script from "./MypageMessageNotice.vue?vue&type=script&lang=js"
export * from "./MypageMessageNotice.vue?vue&type=script&lang=js"
import style0 from "./MypageMessageNotice.vue?vue&type=style&index=0&id=24f83487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f83487",
  null
  
)

export default component.exports